export default "__VITE_ASSET__D144KTsz__"